export default function Insight() {
  return (
    <section className="bg-gradient-to-r from-green-700 to-green-600 py-20 text-center text-white">
      <div className="max-w-3xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold mb-4">
          Start Collecting Insights Today
        </h2>

        {/* Subtext */}
        <div className="max-w-2xl mx-auto px-6">
          <p className="text-lg mb-8 text-gray-100">
            Join thousands of companies making smarter decisions with real user
            feedback from our engaged community
          </p>
        </div>
        {/* Button */}
        <button
          onClick={() => {
            document
              .getElementById("contact-form")
              .scrollIntoView({ behavior: "smooth" });
          }}
          className="bg-white text-green-600 px-6 py-3 rounded-lg font-medium shadow-md hover:bg-gray-100 transition"
        >
          Sign Up Now
        </button>

        {/* Small text */}
        <p className="text-sm text-gray-200 mt-6">
          No setup fees • Cancel anytime • 14-day free trial
        </p>
      </div>
    </section>
  );
}
